import { defineMessages } from 'react-intl';

export default defineMessages({
  chooseHPLCPurification: {
    id: 'chooseHPLCPurification',
    defaultMessage: 'To choose HPLC purification, please use our'
  },
  configuratorLink: {
    id: 'configuratorLink',
    defaultMessage: 'RNAi configurator'
  },
  customsiRNALink: {
    id: 'customsiRNALink',
    defaultMessage: 'To order custom siRNA, please use our {geneAssistUrl}'
  },
  geneAssistUrl: {
    id: 'geneAssistUrl',
    defaultMessage: 'GeneAssist siRNA Tool.'
  }
});
